import moment from 'moment';

const generateName = (pattern) => {
  
  if(!pattern.format) pattern.format = 'REVIT';

  if(!pattern.name) return "untitled";

  var text = pattern.name + "";

  text = text.replace(/{type}/g, pattern.type.toLowerCase());
  text = text.replace(/{units}/g, pattern.units.toLowerCase());
  text = text.replace(/{format}/g, pattern.format.toLowerCase());

  text = text.replace(/{TYPE}/g, pattern.type.toUpperCase());
  text = text.replace(/{UNITS}/g, pattern.units.toUpperCase());
  text = text.replace(/{FORMAT}/g, pattern.format.toUpperCase());

  // text = text.replace(/{rows}/ig, pattern.rows.length);
  // text = text.replace(/{scale}/ig, pattern.scale_factor);

  text = text.replace(/{date}/ig, moment(pattern.updated_on).format('YYYY-MM-DD'));  
  text = text.replace(/{time}/ig, moment(pattern.updated_on).format('HH:mm:ss')); 


  if(pattern.format === 'AUTOCAD'){
    text = text.replace(/[^A-Za-z0-9]+/g, '');
  } 

  return text;
}

export default generateName;


// WEBPACK FOOTER //
// ./src/pattern_utilities/generateName.js